import React from 'react';

// matplotlib gist_earth sampled at 5 stops — dark navy through teal/green
// to olive/tan to near-white. Visually representative of the precomputed
// basemap tiles rather than pixel-matched.
const GIST_EARTH_CSS_GRADIENT =
  'linear-gradient(to right, #000000 0%, #1d5e56 25%, #65992d 50%, #cab155 75%, #fdfbfb 100%)';

interface AgbMapLegendProps {
  // Raw basemap rescale bounds in Mg/ha — the vmin/vmax the precompute
  // script passed to matplotlib. Displayed as-is.
  rescale: [number, number];
}

// Layout-neutral: the caller is responsible for positioning (absolute bottom-left
// on the Explorer map; stacked with the year slider inside a flex column on the
// Detail map when AGB is the active data layer). Keeping positioning at the
// call site lets us group related controls cleanly without the component
// fighting its parent for a corner of the map.
export const AgbMapLegend: React.FC<AgbMapLegendProps> = ({ rescale }) => {
  const [vmin, vmax] = rescale;
  return (
    <div className="bg-figma-card/90 border border-figma-lime/30 rounded-lg px-3 py-2 shadow-figma-card backdrop-blur-sm w-[220px]">
      <div className="text-[11px] font-roboto-mono uppercase tracking-wider text-neutral-400 mb-1.5">
        Above-ground biomass
      </div>
      <div
        className="h-3 w-full rounded-sm"
        style={{ background: GIST_EARTH_CSS_GRADIENT }}
      />
      <div className="flex items-center justify-between text-[10px] font-roboto-mono text-neutral-400 mt-1">
        <span>{vmin} Mg/ha</span>
        <span>{vmax} Mg/ha</span>
      </div>
    </div>
  );
};
